import React, { useContext, useMemo } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import { AuthContext } from '../contexts/authContext';
import Layout from '../layout';
import { UserRole } from '../models/User';

const AdminLayoutWrapper = ({ adminSubRoutes, routes }) => {
  const { pathname } = useLocation();
  const { authUser } = useContext(AuthContext);

  const isAdmin = useMemo(
    () => authUser && [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser]
  );

  const menuIndex = 0;
  const isViewRates = pathname === '/' || pathname === '';
  const isAuditRates = pathname === '/audit';
  const isUploadRates = pathname === '/upload';
  const skipFullPageLoader = isViewRates || isAuditRates || isUploadRates;

  return (
    <Layout
      disableLoading
      menuIndex={menuIndex}
      routes={routes}
      showCarriersNavigation={isAdmin}
      skipFullPageLoader={skipFullPageLoader}
    >
      <Switch>
        {adminSubRoutes.map((route) => (
          <Route
            key={route.path}
            exact={route.exact}
            path={route.path}
            render={() => <route.component disableLayout routes={routes} />}
          />
        ))}
      </Switch>
    </Layout>
  );
};

export default AdminLayoutWrapper;
